import React from 'react';

import { CommandCenterHouseholdProfile } from '@ndvr/customer-api';

import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { formatCurrency } from 'utils';

interface HouseholdOverviewHeaderProps {
    accountData?: CommandCenterHouseholdProfile;
    totalAum: number;
}

export const HouseholdOverviewHeader = ({ accountData, totalAum }: HouseholdOverviewHeaderProps) => {
    return (
        <Card className="border-border mb-4 flex items-center justify-between rounded-lg border bg-white p-3">
            <div className="flex-1 text-center">
                <div className="mb-1 text-sm text-gray-500">AUM</div>
                <div className="text-xl font-semibold">{formatCurrency(totalAum)}</div>
            </div>
            <Separator orientation="vertical" className="mx-4 h-12" />
            <div className="flex-1 text-center">
                <div className="mb-1 text-sm text-gray-500">Live Accounts</div>
                <div className="text-xl font-semibold">{accountData?.numberOfPortfolios}</div>
            </div>
        </Card>
    );
};
